<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_weather"></Header>
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    />
    <v-container fluid>
      <v-flex row wrap justify-center>
        <v-tabs
          v-model="model"
          centered
          color="transparent"
          slider-color="rgb(84,110,122)"
        >
          <v-tab
            v-for="tab in tabsData"
            :key="tab.param"
            :href="`#${tab.param}`"
          >
            {{ tab.tabItem }}
          </v-tab>
        </v-tabs>
        <div v-for="tab in tabsData" :key="tab.param">
          <v-layout
            row
            wrap
            justify-center
            v-if="model === tab.param && userMenu1"
          >
            <v-flex xs12 md12 v-if="tab.param === 'weather' && userMenu1">
              <v-layout row wrap>
                <v-flex xs12 md6 class="px-4 panel-block animation-fadeIn">
                  <sub-menu
                    v-if="userMenu1.menu.submenu[0] && userMenuData1"
                    :sub-menu="userMenu1.menu.submenu[0]"
                    :sub-menu-data="userMenuData1"
                    :sub-menu-select-data="userMenu1.menu.fieldsets.fieldset"
                    :response-alert="setResponseAlert"
                    :sub-menu-output-setting="filteredOutputSettings"
                    @openWeatherTimerPage="openTimerPage(1)"
                  ></sub-menu>
                </v-flex>
                <v-flex xs12 md6 class="px-4 panel-block animation-fadeIn">
                  <WeatherFieldItems
                    v-if="userMenu1.menu.submenu[1] && userMenuData1"
                    :sub-menu="userMenu1.menu.submenu[1]"
                    :sub-menu-data="userMenuData1"
                    :response-alert="setResponseAlert"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md12 v-if="tab.param === 'weather2' && userMenu2">
              <v-layout row wrap>
                <v-flex xs12 md6 class="px-4 panel-block animation-fadeIn">
                  <sub-menu
                    v-if="userMenu2.menu.submenu[0] && userMenuData2"
                    :sub-menu="userMenu2.menu.submenu[0]"
                    :sub-menu-data="userMenuData2"
                    :sub-menu-select-data="userMenu2.menu.fieldsets.fieldset"
                    :response-alert="setResponseAlert"
                    :sub-menu-output-setting="filteredOutputSettings"
                    @openWeatherTimerPage="openTimerPage(2)"
                  ></sub-menu>
                </v-flex>
                <v-flex xs12 md6 class="px-4 panel-block animation-fadeIn">
                  <WeatherFieldItems
                    v-if="userMenu2.menu.submenu[1] && userMenuData2"
                    :sub-menu="userMenu2.menu.submenu[1]"
                    :sub-menu-data="userMenuData2"
                    :response-alert="setResponseAlert"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 md12 v-if="tab.param === 'weather3' && userMenu3">
              <v-layout row wrap>
                <v-flex xs12 md6 class="px-4 panel-block animation-fadeIn">
                  <sub-menu
                    v-if="userMenu3.menu.submenu[0] && userMenuData3"
                    :sub-menu="userMenu3.menu.submenu[0]"
                    :sub-menu-data="userMenuData3"
                    :sub-menu-select-data="userMenu3.menu.fieldsets.fieldset"
                    :response-alert="setResponseAlert"
                    :sub-menu-output-setting="filteredOutputSettings"
                    @openWeatherTimerPage="openTimerPage(3)"
                  ></sub-menu>
                </v-flex>
                <v-flex xs12 md6 class="px-4 panel-block animation-fadeIn">
                  <WeatherFieldItems
                    v-if="userMenu3.menu.submenu[1] && userMenuData3"
                    :sub-menu="userMenu3.menu.submenu[1]"
                    :sub-menu-data="userMenuData3"
                    :response-alert="setResponseAlert"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 md12 v-if="tab.param === 'weather4' && userMenu4">
              <v-layout row wrap>
                <v-flex xs12 md6 class="px-4 panel-block animation-fadeIn">
                  <sub-menu
                    v-if="userMenu4.menu.submenu[0] && userMenuData4"
                    :sub-menu="userMenu4.menu.submenu[0]"
                    :sub-menu-data="userMenuData4"
                    :sub-menu-select-data="userMenu4.menu.fieldsets.fieldset"
                    :response-alert="setResponseAlert"
                    :sub-menu-output-setting="filteredOutputSettings"
                    @openWeatherTimerPage="openTimerPage(4)"
                  ></sub-menu>
                </v-flex>
                <v-flex xs12 md6 class="px-4 panel-block animation-fadeIn">
                  <WeatherFieldItems
                    v-if="userMenu4.menu.submenu[1] && userMenuData4"
                    :sub-menu="userMenu4.menu.submenu[1]"
                    :sub-menu-data="userMenuData4"
                    :response-alert="setResponseAlert"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import FlashMessage from "../components/FlashMessage";
import SubMenu from "../components/SubMenu";
import WeatherFieldItems from "../components/WeatherFieldItems";
import { translate } from "../common/HelperFunctions";
import router from "../router";

export default {
  components: {
    Header,
    FlashMessage,
    SubMenu,
    WeatherFieldItems
  },
  data: () => ({
    tabsData: [
      { param: "weather", tabItem: `${translate("lng_screen_weather1_head")}` },
      {
        param: "weather2",
        tabItem: `${translate("lng_screen_weather2_head")}`
      },
      {
        param: "weather3",
        tabItem: `${translate("lng_screen_weather3_head")}`
      },
      { param: "weather4", tabItem: `${translate("lng_screen_weather4_head")}` }
    ],
    model: "weather",
    userMenu1: undefined,
    userMenuData1: undefined,
    userMenu2: undefined,
    userMenuData2: undefined,
    userMenu3: undefined,
    userMenuData3: undefined,
    userMenu4: undefined,
    userMenuData4: undefined,
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    outputSettings: undefined,
    inputSettings: undefined,
    filteredOutputSettings: [],
    filteredInputSettings: [],
    pageRefreshTime: 30,
    timerKey: 0
    // showTimer: false
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    this.userMenu1 = await GlobalService.getMenu("weather", this.getUser.token);

    // ===============  to show the timer button on submenu ===================
    this.userMenu1.menu.submenu[0].field.push({
      "@attributes": {
        helptxtid: "lng_timer_control",
        txtid: "lng_timer_control",
        btntxt: "lng_timer_control",
        type: "weather_time_selection"
      }
    });
    this.outputSettings = await GlobalService.getOutputSettings(
      this.getUser.token
    );
    this.filterOutputSettings();
    this.inputSettings = await GlobalService.getInputSettings(
      this.getUser.token
    );
    this.userMenu2 = await GlobalService.getMenu(
      "weather2",
      this.getUser.token
    );
    this.userMenu2.menu.submenu[0].field.push({
      "@attributes": {
        helptxtid: "lng_timer_control",
        txtid: "lng_timer_control",
        btntxt: "lng_timer_control",
        type: "weather_time_selection"
      }
    });
    this.userMenu3 = await GlobalService.getMenu(
      "weather3",
      this.getUser.token
    );
    this.userMenu3.menu.submenu[0].field.push({
      "@attributes": {
        helptxtid: "lng_timer_control",
        txtid: "lng_timer_control",
        btntxt: "lng_timer_control",
        type: "weather_time_selection"
      }
    });
    this.userMenu4 = await GlobalService.getMenu(
      "weather4",
      this.getUser.token
    );
    this.userMenu4.menu.submenu[0].field.push({
      "@attributes": {
        helptxtid: "lng_timer_control",
        txtid: "lng_timer_control",
        btntxt: "lng_timer_control",
        type: "weather_time_selection"
      }
    });
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      this.userMenuData1 = await GlobalService.getMenuData(
        "weather",
        this.getUser.token
      );
      this.userMenuData2 = await GlobalService.getMenuData(
        "weather2",
        this.getUser.token
      );
      this.userMenuData3 = await GlobalService.getMenuData(
        "weather3",
        this.getUser.token
      );
      this.userMenuData4 = await GlobalService.getMenuData(
        "weather4",
        this.getUser.token
      );
      // this.showTimer = true;
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    async flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
      await this.FetchApisData();
    },
    // filter data for Alarm output dropdown field
    filterOutputSettings() {
      this.outputSettings.forEach(setting => {
        if (setting.txt !== "") {
          this.filteredOutputSettings.push(setting);
        }
      });
      this.filteredOutputSettings.unshift({ id: 0, txt: "" });
    },
    filterInputSettings() {
      this.inputSettings.forEach(setting => {
        if (setting.txt !== "") {
          this.filteredInputSettings.push(setting);
        }
      });
      this.filteredInputSettings.unshift({ id: 0, txt: "" });
    },
    openTimerPage(weatherNumber) {
      router.push(`/weather/weather-timer/${weatherNumber}`);
    }
  }
};
</script>
<style>
.v-tabs__div a {
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  padding: 12px 24px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  text-transform: uppercase;
  float: left;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 1 !important;
  color: rgba(0, 0, 0, 0.54) !important;
}
.v-tabs__div .v-tabs__item--active {
  color: rgb(84, 110, 122) !important;
}
.animation-fadeIn {
  animation-name: fadeIn;
  -webkit-animation-name: fadeIn;
  animation-duration: 0.5s;
  -webkit-animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
  visibility: visible !important;
}
.v-tabs__bar {
  margin-bottom: 10px;
}
@keyframes fadeIn {
  0% {
    transform: scale(0.97);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animation-slideLeft {
  animation-name: slideLeft;
  -webkit-animation-name: slideLeft;
  animation-duration: 3s;
  -webkit-animation-duration: 3s;
  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
  visibility: visible !important;
}

@keyframes slideLeft {
  0% {
    transform: translateX(150%);
  }
  100% {
    transform: translateX(0%);
  }
}

@-webkit-keyframes slideLeft {
  0% {
    -webkit-transform: translateX(150%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

.animation-slideRight {
  animation-name: slideRight;
  -webkit-animation-name: slideRight;
  animation-duration: 3s;
  -webkit-animation-duration: 3s;
  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
  visibility: visible !important;
}

@keyframes slideRight {
  0% {
    transform: translateX(-150%);
  }
  100% {
    transform: translateX(0%);
  }
}

@-webkit-keyframes slideRight {
  0% {
    -webkit-transform: translateX(-150%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}
</style>
